import React, { useState } from 'react';
import BlogLink from '../../BlogLink';
import { Container, Input, Label, Result, Text } from '../../styles';
import Base from '../Base';
import ListTable from './ListTable';



function Loulette() {


  // 変更する
  // ---------------------------------------------
  // 2023.3.22
  // 1040,31200(sum,cost)

  // gold,b,a_coach,b_coach,energy,spi_medal,ticket,point,coin,hit_medal
  const getRate = [0.005190311418685121, 0.006920415224913495, 0.006920415224913495, 0.005190311418685121, 0.05363321799307959, 3.8062283737024223, 0.04325259515570934, 16.089965397923876, 13.321799307958477, 0.058823529411764705]; //獲得数/初期所持メダル

  const medalPerEngrgyInit = 6; //メダル/1エナジー


  // 表示設定
  // ---------------------------------------------
  // const [digits, setDigits] = useState(0);
  const digits = 0;
  const [energy, setEnergy] = useState(250);
  const [medalPerEngrgy, setMedalPerEngrgy] = useState(medalPerEngrgyInit);
  // ---------------------------------------------

  // 確認する
  // 初期設定
  // ---------------------------------------------
  // const needMedal = 3;
  const returnRate = getRate[4] * medalPerEngrgy


  // ---------------------------------------------

  //   集計
  const getRatePerEnergy = [];
  for (let i = 0; i < getRate.length; i++) {
    getRatePerEnergy[i] = getRate[i] * medalPerEngrgy //1エナジーあたりi等が何回当たるか
  }


  //   実質消費エナジー
  const realEnergy = 1 - returnRate;

  //   消費エナジー変更
  const handleEnergyChange = (event) => {
    setEnergy(event.target.value);
  };

  //   桁数変更
  // const handleDigitsChange = (event) => {
  //   if (event.target.value >= 0) {
  //     var dig = event.target.value;
  //   } else {
  //     var dig = 0;
  //   }
  //   setDigits(dig);
  // };


  const calculateItem = () => {
    const getItemPerRealEnergy = [];
    const getItemExpected = [];
    for (let i = 0; i < getRate.length; i++) {
      // getItemPerRealEnergy[i] = getItem[i] / realEnergy;
      getItemPerRealEnergy[i] = getRatePerEnergy[i] / realEnergy; //後で修正

      getItemExpected[i] = ((getItemPerRealEnergy[i] * energy)).toFixed(digits);
    }
    console.log(getItemPerRealEnergy)

    return getItemExpected
  }

  // gold,b,a_coach,b_coach,energy,spi_medal,ticket,point,coin,hit_medal

  const getItemExpected = calculateItem()

  const itemExpectedList = [
    { name: 'ゴールド契約書', result: getItemExpected[0] },
    { name: 'B契約書', result: getItemExpected[1] },
    { name: 'Aランク特訓コーチ', result: getItemExpected[2] },
    { name: 'Bランク特訓コーチ', result: getItemExpected[3] },
    { name: 'スピメダル', result: getItemExpected[5] },
    { name: '試練チケット', result: getItemExpected[6] },
    { name: 'スカウトP', result: getItemExpected[7] },
    { name: 'コイン', result: getItemExpected[8] },
  ];

  return (
    <>
      <Base body={
        <Container>
          <h1>ルーレットヒッター</h1>
          <Label>
            <Text>消費エナジー：</Text>
            <Input type="number" value={energy} onChange={handleEnergyChange} />
          </Label>

          < div >
            <h2>計算結果</h2>
            <ListTable list={itemExpectedList} />
          </div >
          <Result>
            <Text>エナジー還元率:{returnRate.toFixed(3)}</Text>
          </Result>
          <div>
            <p>{energy}エナジー消費した時に得られるアイテム数の期待値がResultに表示されます。</p>
          </div>
          <div>
            <p>※誤差が大きいと思われます。</p>
          </div>
          <BlogLink link={"https://www.sakusaku27.com/"} />
        </Container>

      } title="ルーレットヒッター" />
    </>
  );
}

export default Loulette;
